module.exports = __webpack_public_path__ + "img/logo-tim.4da9a1b6.svg";